import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyPage from "./PolicyPage";
import "../css/delivery.scss";

function Delivery() {
  const formatPrice = (amount) =>
    new Intl.NumberFormat(siteConfig.locale, {
      style: "currency",
      currency: siteConfig.currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

  const sections = [
    {
      id: "dispatch",
      title: "Preparing your order",
      paragraphs: [
        `Orders are normally prepared within ${siteConfig.shipping.dispatchTime}. During launches, public holidays or especially busy periods, preparation may take a little longer.`,
        "Once a parcel leaves the studio, we will send a dispatch confirmation with its carrier and tracking details. Delivery estimates begin from dispatch, not from the moment an order is placed.",
      ],
    },
    {
      id: "rates",
      title: "Rates and delivery estimates",
      paragraphs: [
        `Standard delivery is shown at checkout from ${formatPrice(
          siteConfig.shipping.standardRate
        )}; express delivery is shown from ${formatPrice(
          siteConfig.shipping.expressRate
        )}. The final rate for the selected destination and available service is displayed before payment.`,
        "The following windows are estimates, begin after dispatch and are not guaranteed arrival dates:",
      ],
      items: [
        "Hong Kong: approximately 1–3 working days after dispatch.",
        "Other supported destinations: approximately 5–12 working days after dispatch.",
      ],
    },
    {
      id: "destinations",
      title: "Destinations, duties and taxes",
      paragraphs: [
        "Available destinations and final delivery prices are confirmed during checkout. Some islands, remote areas and post-office boxes may need a different service or may be unavailable.",
        "Taxes collected by us are included or shown at checkout. For an international order, the destination authority or carrier may separately collect import duty, tax or a clearance charge. Unless checkout expressly states that these charges are prepaid, the recipient is responsible for them. We cannot mark an order as a gift or declare an inaccurate value.",
      ],
    },
    {
      id: "restrictions",
      title: "Delivery restrictions",
      paragraphs: [
        "We may be unable to dispatch to a destination affected by carrier limits, trade sanctions, import restrictions or product-specific transport rules. An order may also be held until information needed for customs or address verification is supplied. If lawful delivery cannot be arranged, the affected order will be cancelled and refunded.",
      ],
    },
    {
      id: "address",
      title: "Addresses and delivery attempts",
      paragraphs: [
        "Please check the delivery address before completing an order. Contact customer care as soon as possible if something is incorrect; an address cannot always be changed once packing or transit has begun.",
        "The carrier may make a limited number of delivery attempts or send a parcel to a collection point. If a parcel is returned because it was not collected or the address was incomplete, any new delivery cost may be deducted from the refund where local law permits.",
      ],
    },
    {
      id: "delays",
      title: "Delays, loss or damage in transit",
      paragraphs: [
        "Tracking can take up to 48 hours to update. Weather, customs inspections and carrier disruption can delay a parcel beyond its original estimate.",
        `If tracking has not changed for five working days, or your parcel arrives visibly damaged, keep the packaging and contact ${siteConfig.contact.email}. Include your order number and clear photographs where relevant so the delivery can be investigated. Your statutory rights remain unaffected.`,
      ],
    },
    {
      id: "split",
      title: "Split shipments",
      paragraphs: [
        "Where operationally necessary, an order may be sent in more than one parcel. We will provide available tracking for each parcel and will not add delivery charges beyond the amount agreed at checkout unless you request a separate service after ordering.",
      ],
    },
    {
      id: "risk",
      title: "Delivery, title and risk",
      paragraphs: [
        "A parcel is treated as delivered when it reaches the address provided, a person authorised by you, or a collection point selected under the carrier's instructions. Risk passes at delivery, subject to mandatory consumer law. Title to the goods passes after full payment is received.",
      ],
    },
  ];

  return (
    <div className="delivery">
      <PolicyPage
        title="Shipping"
        intro={`Delivery information for orders placed with ${siteConfig.brandName}, including preparation, estimates and tracking.`}
        sections={sections}
        relatedLinks={[
          { label: "Returns", to: "/returns" },
          { label: "Cancellation policy", to: "/cancellations" },
          { label: "Contact customer care", to: "/contact" },
          { label: "All policies", to: "/policies" },
        ]}
      />
    </div>
  );
}

export default Delivery;
